import {CardEnum} from '@colonist/game-states'

export class GameModeDevelopmentCardData {
    static readonly developmentCardsClassic4P = [
        ...Array(14).fill(CardEnum.Knight),
        ...Array(5).fill(CardEnum.VictoryPoint),
        ...Array(2).fill(CardEnum.RoadBuilding),
        ...Array(2).fill(CardEnum.Monopoly),
        ...Array(2).fill(CardEnum.YearOfPlenty),
    ]

    static readonly developmentCardsClassic56P = [
        ...Array(20).fill(CardEnum.Knight),
        ...Array(5).fill(CardEnum.VictoryPoint),
        ...Array(3).fill(CardEnum.RoadBuilding),
        ...Array(3).fill(CardEnum.Monopoly),
        ...Array(3).fill(CardEnum.YearOfPlenty),
    ]

    static readonly developmentCardsClassic78P = [
        ...Array(26).fill(CardEnum.Knight),
        ...Array(5).fill(CardEnum.VictoryPoint),
        ...Array(4).fill(CardEnum.RoadBuilding),
        ...Array(4).fill(CardEnum.Monopoly),
        ...Array(4).fill(CardEnum.YearOfPlenty),
    ]

    static readonly progressCardsCitiesAndKnights4P = [
        ...Array(2).fill(CardEnum.ProgressCardScienceAlchemist),
        ...Array(2).fill(CardEnum.ProgressCardScienceCrane),
        ...Array(1).fill(CardEnum.ProgressCardScienceEngineer),
        ...Array(2).fill(CardEnum.ProgressCardScienceInventor),
        ...Array(2).fill(CardEnum.ProgressCardScienceIrrigation),
        ...Array(2).fill(CardEnum.ProgressCardScienceMedicine),
        ...Array(2).fill(CardEnum.ProgressCardScienceMining),
        ...Array(1).fill(CardEnum.ProgressCardSciencePrinter),
        ...Array(2).fill(CardEnum.ProgressCardScienceRoadBuilding),
        ...Array(2).fill(CardEnum.ProgressCardScienceSmith),
        ...Array(2).fill(CardEnum.ProgressCardPoliticsBishop),
        ...Array(1).fill(CardEnum.ProgressCardPoliticsConstitution),
        ...Array(2).fill(CardEnum.ProgressCardPoliticsDeserter),
        ...Array(2).fill(CardEnum.ProgressCardPoliticsDiplomat),
        ...Array(2).fill(CardEnum.ProgressCardPoliticsIntrigue),
        ...Array(2).fill(CardEnum.ProgressCardPoliticsSaboteur),
        ...Array(3).fill(CardEnum.ProgressCardPoliticsSpy),
        ...Array(2).fill(CardEnum.ProgressCardPoliticsWarlord),
        ...Array(2).fill(CardEnum.ProgressCardPoliticsWedding),
        ...Array(2).fill(CardEnum.ProgressCardTradeCommercialHarbor),
        ...Array(2).fill(CardEnum.ProgressCardTradeMasterMerchant),
        ...Array(6).fill(CardEnum.ProgressCardTradeMerchant),
        ...Array(2).fill(CardEnum.ProgressCardTradeMerchantFleet),
        ...Array(4).fill(CardEnum.ProgressCardTradeResourceMonopoly),
        ...Array(2).fill(CardEnum.ProgressCardTradeCommodityMonopoly),
    ]
}
